import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountService, AlertService, ConnectionService } from '@app/_services';
import { Router, ActivatedRoute } from "@angular/router";
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-forget-password',
  templateUrl: 'forgetpassword.component.html'
})
export class ForgetPasswordComponent implements OnInit {
  forgetPasswordForm: FormGroup;
  loading = false;
  submitted = false;
  errormsg = '';
  isSuccess = false;
  

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private accountService: AccountService,
    private alertService: AlertService,
    private Router: Router
  ) {

  }
  ngOnInit() {
    this.forgetPasswordForm = this.fb.group({
      username: ['', [Validators.required]]
    });

  }
  get f() { return this.forgetPasswordForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.errormsg = '';
    this.isSuccess = false;
  
    // reset alerts on submit
    //this.alertService.clear();

    // stop here if form is invalid
    if (this.forgetPasswordForm.invalid) {
      return;
    }

    this.loading = true;
    this.accountService.fogetpassword({ username: this.f.username.value }).subscribe(response => {
      
      if (response.message!='' && response.message == "SUCCESS") {
        this.loading = false;
        this.isSuccess = true;      
      }
      else {                
        this.errormsg = response.message;
        this.loading = false;
        setTimeout(() => {
          this.errormsg = '';
        },5000)
      }

    }, error => {
      //this.alertService.error(error);
      this.loading = false;
      this.errormsg = error;
     
    });
    
  }

  returnToLogin() {
    this.alertService.clear();
    this.activeModal.close();
    this.Router.navigate([`/account/login`]);
  }

  onCloseDialog() {
    this.activeModal.close();
  }

}
